// Author Lin
// Date 2021-11-03 17:22:46

import * as model from "@/model/mintalMes/mst/MintalMesMstPowerStationMeterModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesMstPowerStationMeter(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_MST_URL,
    })
    .buildStore()
